/**
 * Footer Component
 * 
 * Multi-column footer with about section, quick links, legal links, and contact info.
 */

import '../styles/updated.css'

function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-content">
        <div className="footer-grid">
          {/* About Section */}
          <div className="footer-column">
            <h3 className="footer-heading">ÜBER UNS</h3>
            <div className="footer-brand">
              <strong>Online-Kredit</strong>
            </div>
            <p className="footer-description">
              Ihre vertrauenswürdige Lösung für schnelle und zuverlässige Kreditvergabe zu 100% digital.
            </p>
            {/* <a href="#" className="footer-learn-more">
              Mehr erfahren →
            </a> */}
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h3 className="footer-heading">SCHNELLZUGRIFF</h3>
            <nav className="footer-nav" aria-label="Quick Links">
              <a href="/" className="footer-link">
                <span className="link-icon">›</span> Registrieren
              </a>
              <a href="/" className="footer-link">
                <span className="link-icon">›</span> Dienstleistungen
              </a>
              <a href="/" className="footer-link">
                <span className="link-icon">›</span> FAQ
              </a>
              {/* <a href="#" className="footer-link">
                <span className="link-icon">›</span> Über uns
              </a> */}
              {/* <a href="#" className="footer-link">
                <span className="link-icon">›</span> Erfahrungsberichte
              </a> */}
              {/* <a href="#" className="footer-link">
                <span className="link-icon">›</span> Kontakt
              </a> */}
            </nav>
          </div>

          {/* Legal Links - Updated to link to legal page */}
          <div className="footer-column">
            <h3 className="footer-heading">RECHTLICHES</h3>
            <nav className="footer-nav" aria-label="Legal Links">
              <a href="/legal#legal-notice" className="footer-link">
                <span className="link-icon">›</span> Impressum
              </a>
              <a href="/legal#privacy" className="footer-link">
                <span className="link-icon">›</span> Datenschutzerklärung
              </a>
              <a href="/legal#cookies" className="footer-link">
                <span className="link-icon">›</span> Cookie-Richtlinie
              </a>
              <a href="/legal#terms" className="footer-link">
                <span className="link-icon">›</span> AGB
              </a>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h3 className="footer-heading">KONTAKT</h3>
            <div className="footer-contact">
              <div className="contact-item">
                <i className="fas fa-map-marker-alt" aria-hidden="true"></i>
                <span>Malmöer Str. 16<br/>10439 Berlin, Deutschland</span>
              </div>
              <div className="contact-item">
                <i className="fas fa-envelope" aria-hidden="true"></i>
                <a href="mailto:contact@schnelleronlinekredit.de">contact@schnelleronlinekredit.de</a>
              </div>
              <div className="contact-item">
                <i className="fas fa-phone" aria-hidden="true"></i>
                <a href="tel:+4930123456789">+49 15 732 306 680</a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        {/* <div className="footer-bottom">
          <p className="copyright">
            © {currentYear} <strong>Online-Kredit</strong>. Alle Rechte vorbehalten.
          </p>
          <div className="social-links" aria-label="Social Media">
            <a href="#" className="social-link" aria-label="Facebook">
              <i className="fab fa-facebook-f"></i>
            </a>
            <a href="#" className="social-link" aria-label="Twitter">
              <i className="fab fa-twitter"></i>
            </a>
            <a href="#" className="social-link" aria-label="LinkedIn">
              <i className="fab fa-linkedin-in"></i>
            </a>
            <a href="#" className="social-link" aria-label="Instagram">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="#" className="social-link" aria-label="WhatsApp">
              <i className="fab fa-whatsapp"></i>
            </a>
          </div>
        </div> */}
      </div>
    </footer>
  )
}

export default Footer